/**
 * Backend step labels, titles and descriptions are authored by customers and still say
 * "training" (e.g. `Hazmat_Training`), while the product wording is "certification".
 * Every place that renders backend-authored copy runs it through this helper (ENG-780).
 *
 * Display only — values sent back to the API must keep their original wording, and HTML
 * blocks are left alone so URLs and attributes can't be rewritten.
 */
const TRAINING_WORD_PATTERN = /(^|[^a-zA-Z0-9])(trainings?)(?![a-zA-Z0-9])/gi

const applyCasingOf = (source: string, replacement: string): string => {
  if (source === source.toUpperCase()) {
    return replacement.toUpperCase()
  }

  if (source.charAt(0) === source.charAt(0).toUpperCase()) {
    return `${replacement.charAt(0).toUpperCase()}${replacement.slice(1)}`
  }

  return replacement
}

export const replaceTrainingWording = (text: string): string => {
  if (!text) {
    return text
  }

  return text.replace(TRAINING_WORD_PATTERN, (_match, prefix: string, word: string) => {
    const replacement = word.toLowerCase().endsWith('s') ? 'certifications' : 'certification'

    return `${prefix}${applyCasingOf(word, replacement)}`
  })
}
